import axios from 'axios';
import Common from './Common';
export default {
    getPoints(id) {
        return axios.get(Common.api + 'accounts-info/' + id);
    },
    getHistory(id) {
        return axios.get(Common.api + 'withdrawal-history/' + id);
    },
    getFollowers(id) {
        return axios.get(Common.api + 'seller-followers/' + id);
    },
    WithdrawPoints(data) {
        return axios.post(Common.api + 'apply-for-withdrawal' ,data);
    },
    getLegality(id) {
        return axios.get(Common.api + 'check-legality/' +id);
    }
}